<template>
  <router-view v-if="initialised" />
</template>

<script>
  export default {
    data() {
      return {
        initialised: false,
        
      };
    },
    async created() {
      this.initialise_auth(this);
      let loginValid = await this.verify_login();

      if(loginValid) {
        // this.$router.push('/questionnaire')
      } else {
        this.$router.push('/login')
      }
    },
    mounted() {
      /* eslint-disable */
      ImportModules(null, () => {
        this.$nextTick(() => {
          this.initialised = true;
        });
      });
    }
  };
</script>

<style>
  html,
  body {
    overflow: hidden !important;
  }
</style>